// modules/headerNavigation.js

export function headerNavigation() {
	let closeTimer = null
	const CLOSE_DELAY = 500

	function initHeader() {
		document.querySelector('.site__header')?.classList.add('is-loaded')
	}

	function closeAllContainers() {
		document.querySelectorAll('.nav-target-container').forEach(container => {
			container.classList.remove('active')
		})
	}

	function scheduleClose() {
		clearTimeout(closeTimer)
		closeTimer = setTimeout(closeAllContainers, CLOSE_DELAY)
	}

	function cancelClose() {
		clearTimeout(closeTimer)
	}

	initHeader()

	document.querySelectorAll('li[data-nav-id]').forEach(li => {
		li.addEventListener('mouseenter', function () {
			cancelClose()

			const hasChildren = this.classList.contains('has-children')
			const navId = this.dataset.navId

			document.querySelectorAll('.nav-target-container').forEach(container => {
				container.classList.toggle(
					'active',
					hasChildren && container.dataset.navId === navId
				)
			})
		})

		li.addEventListener('mouseleave', scheduleClose)
	})

	document.querySelectorAll('.nav-target-container').forEach(container => {
		container.addEventListener('mouseenter', cancelClose)
		container.addEventListener('mouseleave', scheduleClose)
	})
}